<template lang="pug">
  v-dialog(v-model="show", persistent, max-width="50%")
    v-card
      v-card-title
        v-flex.md8.title Boletos
        v-flex.md4.text-xs-right
          v-btn(flat, @click="show = false;", density="comfortable", icon="", variant="plain")
            v-icon close
      v-card-text.pa-0
        boletos(ref="boletos")
</template>
  
<script>
import boletos from '@/pages/financeiro/boleto/Lista';

export default {
  components: {
    boletos,
  },
  data () {
    return {
      show : false
    }
  },
  created () {
  },
  watch: {
  },
  computed: {
  },
  methods: {
    open(estabelecimento_id){
      const vm = this;
      vm.show = true;
      this.$refs.boletos.refresh(estabelecimento_id);
    },
    close(){
      const vm = this;
      vm.show = false;
    }
  }
}
</script>